export type MediaDimensions = {
  width?: unknown;
  height?: unknown;
};

export const DEFAULT_IMAGE_DIMENSIONS = {
  width: 600,
  height: 1,
} as const;

export const DEFAULT_VIDEO_PREVIEW_DIMENSIONS = {
  width: 1280,
  height: 720,
} as const;

export const isValidMediaDimension = (value: unknown): value is number => {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
};

export const normalizeMediaDimension = (
  value: unknown,
  fallback: number,
): number => {
  if (isValidMediaDimension(value)) {
    return Math.round(value);
  }

  if (isValidMediaDimension(fallback)) {
    return Math.round(fallback);
  }

  return 1;
};

export const hasValidMediaDimensions = (
  dimensions?: MediaDimensions | null,
) => {
  return (
    isValidMediaDimension(dimensions?.width) &&
    isValidMediaDimension(dimensions?.height)
  );
};

export const getSafeMediaDimensions = (
  dimensions?: MediaDimensions | null,
  fallback: MediaDimensions = DEFAULT_IMAGE_DIMENSIONS,
) => {
  const fallbackWidth = normalizeMediaDimension(
    fallback.width,
    DEFAULT_IMAGE_DIMENSIONS.width,
  );
  const fallbackHeight = normalizeMediaDimension(
    fallback.height,
    DEFAULT_IMAGE_DIMENSIONS.height,
  );

  return {
    width: normalizeMediaDimension(dimensions?.width, fallbackWidth),
    height: normalizeMediaDimension(dimensions?.height, fallbackHeight),
  };
};
